import { FC, ReactNode } from 'react';
import { cn } from '@fe-learner-common/utils';

type PageProps = {
  children: ReactNode;
  className?: string;
};

export const Page: FC<PageProps> = ({ children, className }) => {
  return (
    <main
      className={cn(
        'lf:px-3 lf:py-6 lf:2xl:container lf:lg:px-8 lf:lg:py-6 lf:xl:px-[60px]',
        className,
      )}
    >
      {children}
    </main>
  );
};
